/*
We dynamically update the height of the ad containers when they are rendered
because different creative is different heights. The container will have a
min-height set by the Rails view that reserves space for a loading indicator.
We over-ride that value here with the actual height.
*/
export const updateAdContainerHeight = (event) => {
  const matchedIframe = window.googleAdIframes.find((iframe) => {
    return event.source.window === iframe.contentWindow;
  });

  if (matchedIframe) {
    const parentElement = matchedIframe.closest('.google-ad');
    parentElement.style.height = event.data.newHeight
    parentElement.style.minHeight = event.data.newHeight
  }
}
